import React, {useMemo} from 'react';
import {Card, CardActions, CardContent, Typography} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {arrays, datetime} from "@atttomyx/shared-utils";
import "./questionnaireCard.css";

const QuestionnaireCard = (props) => {
    const { questionnaire, numQuestions = 0, filters, children } = props;

    const description = useMemo(() => {
        return arrays.splitOnNewline(questionnaire.description);
    }, [questionnaire.description]);

    return <Card className="questionnaire-card" raised={true}>
        <CardContent>
            <CardTitle>
                <Typography variant="body1">
                    {questionnaire.title}
                </Typography>
                <Typography variant="caption" className="description">
                    {description.length > 0 ? description[0] : "-"}
                </Typography>
            </CardTitle>
            <CardData
                filters={filters}
                data={questionnaire}
                keyToMetadata={{
                    numQuestions: {
                        title: "Questions",
                        getter: (data) => numQuestions,
                    },
                    status: {
                        title: "Status",
                        className: "status " + questionnaire.status,
                    },
                    order: {
                        title: "Index",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default QuestionnaireCard;
